'use client';

import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { Link } from '@lib/navigation';

export default function LoginLink() {

  const params = useSearchParams();
  const t = useTranslations('auth');

  const getLoginLink = () => {
    if (params.has('from')) {
      return `/login?from=${params.get('from')}`;
    }
    return '/login';
  };

  return (
    <div className="px-6 py-1 lg:py-6 text-white text-center">
      <h2 className="mb-4 text-lg font-bold lg:mb-3 lg:text-xl">
        {t('register.registeredAlready')}
      </h2>
      <div className="my-4 flex items-center justify-center">
        <Link
          href={getLoginLink()}
          rel="nofollow"
          className="border-gray-900 text-gray-900 hover:bg-premium-900 block max-w-96 h-[42px] rounded-3xl border bg-white px-4 py-2 text-sm text-center transition-colors hover:text-white"
        >
          {t('register.logIn')}
        </Link>
      </div>
    </div>
  );
}
